import { useTheme } from '@mui/material/styles';
import { DateField, FunctionField, TextField, useTranslate } from 'react-admin';

import { UsageLogEntry } from 'types/LiveLogs';
import { LiveLogDatagrid } from './LiveLogDatagrid';
import { formatDuration, HIDE_BELOW_SM, LIVE_LOGS_I18N, liveLogColumnLabel, LOG_DATE_TIME_FORMAT } from './liveLogs';
import { monoSx, runningTint, tabularSx } from './logCellSx';
import { LogChip } from './LogChip';
import { RunningSessionCard } from './RunningSessionCard';

export const UsageLogGrid = () => {
  const translate = useTranslate();
  const theme = useTheme();
  // Resolved here: Datagrid's rowSx is typed against a theme-less SxProps, so no theme callback.
  const runningRowTint = runningTint(theme);
  const runningRowSx = (record: UsageLogEntry) => (record.is_running ? { bgcolor: runningRowTint } : {});

  const renderDuration = (record: UsageLogEntry) => {
    if (record.is_running) {
      return <LogChip label={translate(`${LIVE_LOGS_I18N}.running.chip`)} color="secondary" />;
    }
    return record.duration != null ? formatDuration(record.duration) : '-';
  };

  return (
    <>
      <RunningSessionCard />
      <LiveLogDatagrid rowSx={runningRowSx}>
        <DateField<UsageLogEntry>
          source="timestamp"
          emptyText="-"
          label={liveLogColumnLabel('time')}
          sortable={false}
          showTime
          options={LOG_DATE_TIME_FORMAT}
          sx={tabularSx}
          cellClassName={HIDE_BELOW_SM}
          headerClassName={HIDE_BELOW_SM}
        />
        <TextField<UsageLogEntry> source="game" label={liveLogColumnLabel('game')} sortable={false} emptyText="-" />
        <DateField<UsageLogEntry>
          source="start_time"
          label={liveLogColumnLabel('start')}
          sortable={false}
          showTime
          options={LOG_DATE_TIME_FORMAT}
          emptyText="-"
          sx={tabularSx}
        />
        <DateField<UsageLogEntry>
          source="end_time"
          label={liveLogColumnLabel('end')}
          sortable={false}
          showTime
          options={LOG_DATE_TIME_FORMAT}
          emptyText="-"
          sx={tabularSx}
          cellClassName={HIDE_BELOW_SM}
          headerClassName={HIDE_BELOW_SM}
        />
        <FunctionField<UsageLogEntry>
          label={liveLogColumnLabel('duration')}
          sortable={false}
          textAlign="right"
          sx={tabularSx}
          render={renderDuration}
        />
        <TextField<UsageLogEntry>
          source="software_version"
          label={liveLogColumnLabel('version')}
          sortable={false}
          emptyText="-"
          sx={monoSx}
          cellClassName={HIDE_BELOW_SM}
          headerClassName={HIDE_BELOW_SM}
        />
      </LiveLogDatagrid>
    </>
  );
};
